import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bucketSearch'
})
export class BucketSearchPipe implements PipeTransform {

  transform(items: any[], searchTerm: string): any[] {
    if (!searchTerm) return items;

    searchTerm = searchTerm.toLowerCase();

    return items.filter(user =>
      user.name.toLowerCase().includes(searchTerm) ||
      user.email.toLowerCase().includes(searchTerm) ||
      user.bucket.some(bucket => bucket.name.toLowerCase().includes(searchTerm))
    );
  }

}
